import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    InitTransactionTab,
    TransactionsActions,
} from '../actions/transactions.actions';
import { EMPTY, Observable, catchError, map, of, switchMap } from 'rxjs';
import { WithdrawService } from 'app/core/withdraw/withdraw.service';
import { Injectable } from '@angular/core';
import { SuccessGetTransaction } from '../actions/transactions.actions';

@Injectable()
export class TransactionActionEffects {
    constructor(
        private actions$: Actions,
        private readonly withdrawService: WithdrawService
    ) {}

    initTransactionTab$ = createEffect(() =>
        this.actions$.pipe(
            ofType<InitTransactionTab>(TransactionsActions.InitTransactionTab),
            switchMap((action) => {
                if (action?.transactionId) {
                    return this.withdrawService
                        .getWithdrawTransaction(action.transactionId)
                        .pipe(
                            map((response) => {
                                return new SuccessGetTransaction(
                                    action.transactionId,
                                    response.result
                                );
                            }),
                            catchError((error) => {
                                console.error(error);
                                return of(error);
                            })
                        );
                } else {
                    return EMPTY as Observable<any>;
                }
            })
        )
    );
}
